var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveFine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#88D4FF",
    stroke: "#88D4FF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_127396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_127396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 32C21.3778 32 19.0444 31.2556 17 29.7667C14.9556 28.2778 13.5111 26.3556 12.6667 24H8V21.3333H12.0667C12 20.8 11.9722 20.3056 11.9833 19.85C11.9944 19.3944 12.0222 19 12.0667 18.6667H8V16H12.6667C13.5111 13.6444 14.9556 11.7222 17 10.2333C19.0444 8.74444 21.3778 8 24 8C25.5333 8 26.9833 8.27222 28.35 8.81667C29.7167 9.36111 30.9333 10.1111 32 11.0667L30.1 12.9333C29.2778 12.2222 28.35 11.6667 27.3167 11.2667C26.2833 10.8667 25.1778 10.6667 24 10.6667C22.1111 10.6667 20.4222 11.1611 18.9333 12.15C17.4444 13.1389 16.3222 14.4222 15.5667 16H24V18.6667H14.7667C14.6778 19.2667 14.6444 19.7944 14.6667 20.25C14.6889 20.7056 14.7222 21.0667 14.7667 21.3333H24V24H15.5667C16.3222 25.5778 17.4444 26.8611 18.9333 27.85C20.4222 28.8389 22.1111 29.3333 24 29.3333C25.1778 29.3333 26.2833 29.1333 27.3167 28.7333C28.35 28.3333 29.2778 27.7778 30.1 27.0667L32 28.9333C30.9333 29.8889 29.7167 30.6389 28.35 31.1833C26.9833 31.7278 25.5333 32 24 32Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFine);
export default __webpack_public_path__ + "static/media/ActiveFine.a602aaa8b29eb3242b1b97ceaaa8c729.svg";
export { ForwardRef as ReactComponent };